export default "__VITE_ASSET__DSiD2DvG__"